import NotFound from "../pages/utility/pages-404"
import NotAuthorized from "../pages/utility/pages-401"
import InternalServerError from "../pages/utility/pages-500"

export default [
  { path: "/404", component: NotFound },
  { path: "/401", component: NotAuthorized },
  { path: "/500", component: InternalServerError },
]
